/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions andchangeInterimDate
 * limitations under the License.
 */

import { Component, ComponentFactoryResolver, ComponentRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ReportService } from '../../../../services/report.service';
import { ChecklistProvider, DocumentProvider, ReportEntityProvider, ReportProvider } from '../../../../providers';
import {
  CheckListEntityFinancials, PurchaseAgreement,
  PurchaseAgreementType, Report, CorporateEntity, Helpers, Document, User
} from '../../../../model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { Subject } from 'rxjs';
import {
  ChecklistFinancialsModal, EngageReportModal, RequestInfoModal, CopyFinancialYearModal, EngageReportManualModal,
  ChangeFinancialDateModal, ConfirmDeleteCustomDocumentModal, EngageReportFileModal, DocumentsActionModal
} from '../modals';
import { SearchableItem } from '../../../../model/interface/searchable.item';
import { PresetValue } from '../../../../model/preset-value';
import { FinancialType } from '../../../../model/enums/financial.type';
import { SearchableSelection } from '../../../../model/interface/searchable.selection';
import { CheckListEntityDetails, CheckListFinancialsSetup, ReasonOfValuationType } from '../../../../model/checklist';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver/dist/FileSaver';
import * as moment from 'moment';
import { ReportValuationType, DocumentState, ReportClientUser } from '../../../../model/report';
import { InputType } from '../../../../model/enums/input.type';
import { ReportPageInterface } from '../../../../model/interface/report.page';
import { CustomDocuments } from 'src/app/model/custom.documents';
import { CreateNewClientUserModal } from 'src/app/components/modal';
import * as FileSaver from 'file-saver';
import { ModeService, UserService,LogService } from 'src/app/services';
import { SystemType } from 'src/app/model/enums/system.type';
import { ConfirmationDialogComponent } from 'src/app/components/fields';
import { BVQReportService, ReportSourceService } from 'src/app/modules/bvq/services';
import { BVQReport } from 'src/app/model/bvq';
import { DocumentType } from 'src/app/model/enums/document.type';
import { DocumentActionType } from 'src/app/model/document';
import { FormType } from 'src/app/model/enums/form.type';

@Component({
  selector: 'page-report-checklist',
  templateUrl: 'report.checklist.page.html',
  styleUrls: ['report.checklist.page.scss'],
  styles: [
    `
      :host > .tooltip-inner {
        width: 500px;
        max-width: 500px;
        color: black;
        background-color: #ffffff;
        transition: all 200ms ease;
        border: 1px solid #d4d4d4;
        text-align: left;
        border-radius: 0;
        font-size: 14px;
      }
      :host > .tooltip.top .tooltip-arrow:before,
      :host > .tooltip.top .tooltip-arrow {
        border-top-color: #d4d4d4;
      }
    `
  ],
})
export class ReportChecklistPage implements OnInit, OnDestroy, ReportPageInterface {
  @ViewChild(BsDatepickerDirective) datepicker: BsDatepickerDirective;
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;

  public tooltip: ComponentRef<any>;
  isEngageModalOpen = false;

  isCollapsed = true;
  isDownloading = false;
  isLoadingPreview = false;
  isLoading = false;

  currentReport: Report;
  private reportSub: any;
  private reportLockSub: any;
  private bvqReportSub:any;
  bvqReport: BVQReport = new BVQReport();
  isBVQ: boolean = false;

  PurchaseAgreement = PurchaseAgreement;
  PurchaseAgreementType = PurchaseAgreementType;
  ReasonOfValuationType = ReasonOfValuationType;

  finTypeValues: SearchableItem[] = [
    PresetValue.create('Not Available', FinancialType.NOT_AVAILABLE),
    PresetValue.create('Request', FinancialType.REQUEST),

    PresetValue.create('Internal', FinancialType.INTERNAL),
    PresetValue.create('Federal Tax Return', FinancialType.FEDERAL_TAX_RETURN),
    PresetValue.create('Accountant Compiled', FinancialType.ACCOUNT_COMPILED),
    PresetValue.create('Accountant Reviewed', FinancialType.ACCOUNTANT_REVIEWED),
    PresetValue.create('Audited', FinancialType.AUDITED)
  ];

  finBasisValues: SearchableItem[] = [
    PresetValue.create('Cash', 'Cash'),
    PresetValue.create('Accrual', 'Accrual'),
    PresetValue.create('Hybrid', 'Hybrid')
  ];

  finAllBasisValues: SearchableItem[] = [
    PresetValue.create('Cash', 'Cash'),
    PresetValue.create('Accrual', 'Accrual'),
    PresetValue.create('Hybrid', 'Hybrid')
  ];

  entityTypes: SearchableItem[] = Helpers.getEntityTypes();
  formTypes: SearchableItem[] = [
    PresetValue.create('Form 1065', FormType.FORM_1065),
    PresetValue.create('Form 1120S', FormType.FORM_1120S),
    PresetValue.create('Form 1120', FormType.FORM_1120),
    PresetValue.create('Form 1040 - Schedule C', FormType.SCHEDULE_C),
    PresetValue.create('Form 1040', FormType.FORM_1040),
    PresetValue.create('Form 990', FormType.FORM_990),
    PresetValue.create('Miscellaneous', FormType.OTHER),
  ];

  helperTexts: any[] = Helpers.getBusinessForms();
  stateItems: SearchableItem[] = [];

  typeOfInput = InputType;

  confirmationModal: BsModalRef;
  financials: BsModalRef;
  requestInfoModal: BsModalRef;
  manualEngageModal: BsModalRef;
  fileEngageModal: BsModalRef;
  confirmDelete: BsModalRef;
  editModal: BsModalRef;
  RSState = DocumentState;
  DocumentType = DocumentType;
  isDirtyFlag = false;
  isLocked: boolean;

  BS_DATE: Date = new Date();
  newDoc: CustomDocuments;

  currentMode: SystemType;
  modeSub: any;


  isRemindClientLoading = false;
  isDownloadZipLoading = false;
  isDownloadCombineLoading =false;

  reasonForValuation: SearchableItem[] = [
    PresetValue.create('Sale/Acquisition', ReasonOfValuationType.SALE_ACQUISITION),
    PresetValue.create('Refinance of Debt', ReasonOfValuationType.REFINANCE_OF_DEBT),
    PresetValue.create('Collateralization', ReasonOfValuationType.COLLATERALIZATION),
  ];

  constructor(
    private router: Router,
    private reportProvider: ReportProvider,
    private reportService: ReportService,
    private modalService: BsModalService,
    public checkListProvider: ChecklistProvider,
    private modeService: ModeService,
    private route: ActivatedRoute,
    private reportEntityProvider: ReportEntityProvider,
    private bvqReportService: BVQReportService,
    private souceService: ReportSourceService,
    private documentProvider: DocumentProvider,
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => this.currentReport = currentReport);

    this.bvqReportSub = this.bvqReportService.report$.subscribe(bvq => this.bvqReport = bvq);

    this.reportLockSub = this.reportService.reportLock$.subscribe(value => this.isLocked = value);

    this.modeSub = this.modeService.mode$.subscribe(mode => this.currentMode = mode);

    this.isBVQ = this.route.snapshot.data.bvq ? this.route.snapshot.data.bvq : false;

    this.stateItems = Helpers.getDefaultStates();

    if(!this.isBVQ)
      this.souceService.setSource('TRS');
  }

  ngOnDestroy(): void {
    if (this.reportSub) this.reportSub.unsubscribe();
    if (this.reportLockSub) this.reportLockSub.unsubscribe();
    if (this.modeSub) this.modeSub.unsubscribe();
    if (this.bvqReportSub) this.bvqReportSub.unsubscribe();
  }

  showFinancialsDialog(details: CheckListEntityDetails): void {
    if (!this.isDisabled) {
      this.financials = this.modalService.show(ChecklistFinancialsModal, Helpers.getModalConfig());
      const ackSubject = new Subject<CheckListFinancialsSetup>();
      this.financials.content.subject = ackSubject;

      ackSubject.subscribe(result => {
        if (result) {
          let date = moment(result.INT_DATE).format('YYYY-MM-DD');
          let fye = moment(result.FYE_DATE).format('YYYY-MM-DD');

          this.checkListProvider.setData(this.currentReport.ID, details.ID, result.DATA, date, fye)
            .subscribe(data => {
              if (data.success) {
                const dbCheckDetails = CheckListEntityDetails.parse(data.result);
                details.ENTITY_CHECK_DATE = dbCheckDetails.ENTITY_CHECK_DATE;
                details.BS_ENTITY_CHECK_DATE = dbCheckDetails.BS_ENTITY_CHECK_DATE;
                details.FINANCIALS = dbCheckDetails.FINANCIALS;

                if (details.ENTITY.IS_DEFAULT) {
                  if (details.ENTITY_CHECK_DATE)
                    this.currentReport.DATE_EFFECTIVE = moment(details.ENTITY_CHECK_DATE).format('MMM DD, YYYY');
                }
              } else this.logService.error(JSON.stringify(data, null, 2));
            });
        }
      });
    }
  }

  showChangeDateDialog(details: CheckListEntityDetails): void {
    if (!this.isDisabled) {
      // Sort the financials array in-place by YEAR
      details.FINANCIALS.sort((a, b) => a.YEAR - b.YEAR);
      this.financials = this.modalService.show(ChangeFinancialDateModal, Helpers.getModalConfig());
      const ackSubject = new Subject<CheckListFinancialsSetup>();
      this.financials.content.subject = ackSubject;
      this.financials.content.details = details;
      this.financials.content.field = null;

      ackSubject.subscribe(result => {
        if (result) {
          let date = moment(result.INT_DATE).format('YYYY-MM-DD');
          let fye = moment(result.FYE_DATE).format('YYYY-MM-DD');
          this.checkListProvider.setDate(this.currentReport.ID, details.ID, result.DATA, date, fye)
            .subscribe(data => {
              if (data.success) {
                const dbCheckDetails = CheckListEntityDetails.parse(data.result);
                details.ENTITY_CHECK_DATE = dbCheckDetails.ENTITY_CHECK_DATE;
                details.BS_ENTITY_CHECK_DATE = dbCheckDetails.BS_ENTITY_CHECK_DATE;
                details.FINANCIALS = dbCheckDetails.FINANCIALS;

                if (details.ENTITY.IS_DEFAULT) {
                  if (details.ENTITY_CHECK_DATE)
                    this.currentReport.DATE_EFFECTIVE = moment(details.ENTITY_CHECK_DATE).format('MMM DD, YYYY');
                }

              } else this.logService.error(JSON.stringify(data, null, 2));
            });
        }
      });
    }
  }

  oncopyYears(details: CheckListEntityDetails): void {

    this.financials = this.modalService.show(CopyFinancialYearModal, Helpers.getModalConfig());
    const ackSubject = new Subject<Boolean>();
    this.financials.content.subject = ackSubject;

    ackSubject.subscribe(result => {
      if (result) {
        this.checkListProvider.copyDate(this.currentReport.ID, details.ID).subscribe(data => {
          if (data.success) {
            const dbCheckDetails = CheckListEntityDetails.parse(data.result);
            details.ENTITY_CHECK_DATE = dbCheckDetails.ENTITY_CHECK_DATE;
            details.BS_ENTITY_CHECK_DATE = dbCheckDetails.BS_ENTITY_CHECK_DATE;
            details.FINANCIALS = dbCheckDetails.FINANCIALS;
          }
        });
      }
    });
  }

  showEngage(): void {
    const factory = this.resolver.resolveComponentFactory(EngageReportModal);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
    this.tooltip.instance.isResend = this.currentReport.STAGE.ORDER >= 8 && this.currentReport.showResendEnggletter();

    const ackSubject = new Subject<boolean>();
    this.tooltip.instance.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value === true) {
        this.router.navigate(['/report', this.currentReport.ID, 'general']);
      }

      if (this.tooltip) {
        this.tooltip.destroy();
      }
    });
  }

  showEngageManual(): void {
    // Prevent multiple modal openings
    if (this.tooltip || this.isEngageModalOpen) {
      return;
    }

    this.isEngageModalOpen = true;

    const factory = this.resolver.resolveComponentFactory(EngageReportManualModal);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
    this.tooltip.instance.isResend = this.currentReport.STAGE.ORDER >= 8 && this.currentReport.showResendEnggletter();

    const ackSubject = new Subject<boolean>();
    this.tooltip.instance.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        this.router.navigate(['/report', this.currentReport.ID, 'general']);
      }

      if (this.tooltip) {
        this.tooltip.destroy();
        this.tooltip = null; // Reset to allow reopening
        this.isEngageModalOpen = false; // Reset state
      }
    });

    /* const config = Helpers.getModalConfig();
    config.class = 'modal-lg';
    this.manualEngageModal = this.modalService.show(EngageReportManualModal, config);
    const ackSubject = new Subject<any>();
    this.manualEngageModal.content.subject = ackSubject;
    this.manualEngageModal.content.isResend = this.currentReport.STAGE.ORDER >= 8 && this.currentReport.showResendEnggletter();


    ackSubject.subscribe(value => {
      if (value === true) {
        this.refreshReport();
        this.reportService.showSuccessDialog();
        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate(['/report', this.currentReport.ID, 'general']);
      }
    }); */
  }

  finTypeChanged(did: string, field: string, fin: CheckListEntityFinancials, value: SearchableSelection): void {
    fin.TYPE = value != null ? value.VALUE : null;

    if (fin.isFullDisable()) {
      fin.FULL = false;
      fin.IS_BASIS = null;
      fin.TAX_TYPE = null;

      // Make these calls AFTER the main TYPE update
            setTimeout(() => {
              this.formTypeChanged(did, 'TAX_TYPE', fin, null);
              this.finBasisChanged(did, 'IS_BASIS', fin, null);
            }, 100);
    }


    this.setDataFinField(did, fin.ID, field, fin.TYPE);
  }

  formTypeChanged(did: string, field: string, fin: CheckListEntityFinancials, value: SearchableSelection): void {
    fin.TAX_TYPE = value != null ? value.VALUE : null;
    this.setDataFinField(did, fin.ID, field, fin.TAX_TYPE);
  }

  formBSTypeChanged(did: string, field: string, fin: CheckListEntityFinancials, value: SearchableSelection): void {
    fin.BS_TAX_TYPE = value != null ? value.VALUE : null;
    this.setDataFinField(did, fin.ID, field, fin.BS_TAX_TYPE);
  }

  finBasisChanged(did: string, field: string, fin: CheckListEntityFinancials, value: SearchableSelection): void {
    const sBasis = value != null ? value.VALUE : null;
    fin.IS_BASIS = sBasis;
    this.findOrAddBasisValue(sBasis, field, fin);
    this.setDataFinField(did, fin.ID, field, fin.IS_BASIS);
  }

  finBSTypeChanged(did: string, field: string, fin: CheckListEntityFinancials, value: SearchableSelection): void {
    fin.BS_TYPE = value != null ? value.VALUE : null;

    if (fin.isBsBasisClear()) {
      fin.BS_BASIS = null;
    }

    this.setDataFinField(did, fin.ID, field, fin.BS_TYPE);
  }

  finBSBasisChanged(did: string, field: string, fin: CheckListEntityFinancials, value: SearchableSelection): void {
    const sBasis = value != null ? value.VALUE : null;
    fin.BS_BASIS = sBasis;
    this.findOrAddBasisValue(sBasis, field, fin);
    this.setDataFinField(did, fin.ID, field, fin.BS_BASIS);
  }

  setField(field: string, value: any): void {
    this.checkListProvider.setField(this.currentReport.ID, field, value)
      .subscribe(data => {
        if (!data.success) {
          this.logService.error(JSON.stringify(data, null, 2));
        }
      });
  }

  onDocumentClick(field: string, value: any): void {
    if (this.currentReport.CHECK_LIST[field] == value)
      this.currentReport.CHECK_LIST[field] = null;
    else
      this.currentReport.CHECK_LIST[field] = value;

    this.setField(field, this.currentReport.CHECK_LIST[field]);
  }

  setPurchaseAgreementField(field: string, value: any): void {
    this.cleaarPurchaseAgreement(field, value);
    this.checkListProvider.setField(this.currentReport.ID, field, value)
      .subscribe(data => {
        if (!data.success) {
          this.logService.error(JSON.stringify(data, null, 2));
        }
      });
  }

  setFieldValuationType(field: string, value: any): void {
    this.checkListProvider.setField(this.currentReport.ID, field, value)
      .subscribe(data => {
        if (data.success) {
          if (this.currentReport.VALUATION_TYPE !== ReportValuationType.TO_BE_DETERMINED) {
            if (value === PurchaseAgreementType.STOCK)
              this.currentReport.VALUATION_TYPE = ReportValuationType.STOCK;
            else if (value === PurchaseAgreementType.ASSET)
              this.currentReport.VALUATION_TYPE = ReportValuationType.ASSET;
            else if (value === PurchaseAgreementType.TO_BE_DETERMINED)
              this.currentReport.VALUATION_TYPE = ReportValuationType.TO_BE_DETERMINED;
            else this.currentReport.VALUATION_TYPE = null;

            this.reportProvider.save(this.currentReport.ID, 'VALUATION_TYPE', this.currentReport.VALUATION_TYPE)
              .subscribe(resp => {
                if (!resp.success)
                  this.logService.error(JSON.stringify(resp, null, 2));
              });
          }
        } else this.logService.error(JSON.stringify(data, null, 2));
      });
  }

  setReasonFieldForValuationType(field: string, value: any): void {
    this.checkListProvider.setField(this.currentReport.ID, field, value)
      .subscribe(data => {
        if (!data.success) {
          this.logService.error(JSON.stringify(data, null, 2));
        }
      });
  }

  setDataField(did: string, field: string, value: any): void {
    this.checkListProvider.setDataField(this.currentReport.ID, did, field, value)
      .subscribe(data => {
        if (!data.success)
          this.logService.error(data);
      });
  }

  setToggleField(did: string, value: any, details: CheckListEntityDetails): void {
    this.isLoading = true;
    details.bsDateValue = value ? moment(details.ENTITY_CHECK_DATE, 'YYYY-MM-DD').toDate() : null;
    details.BS_ENTITY_CHECK_DATE = value ? details.ENTITY_CHECK_DATE : null;
    this.checkListProvider.setDataField(this.currentReport.ID, did, 'BS_TOGGLE', value)
      .subscribe(data => {
        if (data.success) {
          for (const fin of details.FINANCIALS) {
            fin.BS_YEAR = value ? fin.YEAR : null;
            fin.BS_DATE = value ? fin.DATE : null;
            fin.BS_TYPE = value ? fin.TYPE : null;
            fin.BS_BASIS = value ? fin.IS_BASIS : null;
            fin.BS_TAX_TYPE = value ? fin.TAX_TYPE : null;
            fin.BS_INTERIM = value ? fin.INTERIM : null;
          }
        }

        this.isLoading = false;
      }, err => {
        this.isLoading = false;
        this.logService.error(JSON.stringify(err, null, 2));
      });
  }

  setDataFinField(did: string, fid: string, field: string, value: any): void {
    this.isLoading = true;
    this.checkListProvider.setDataFinField(this.currentReport.ID, did, fid, field, value)
      .subscribe(data => {
        this.isLoading = false;
        if (!data.success)
          this.logService.error(data);
      });
  }



  openRequestModal(): void {

    const config = Helpers.getModalConfig();
    config.class = 'modal-lg modal-dialog-right';

    this.requestInfoModal = this.modalService.show(RequestInfoModal, config);
    const ackSubject = new Subject<boolean>();
    this.requestInfoModal.content.subject = ackSubject;

    ackSubject.subscribe(result => {
      if (result === true)
        this.currentReport.INITIAL_SENT = true;
    });
  }

  downloadDocuSignDocument(): void {
    this.isDownloading = true;

    this.reportProvider.getDocuSignDocument(this.currentReport.ID)
      .subscribe(response => {
        this.isDownloading = false;

        const blob = new Blob([response], { type: 'application/pdf' });
        saveAs(blob, 'Engagement Letter - Reliant Business Valuation.pdf');
      });
  }

  clearSelf(field: string, value: any): void {
    if (this.currentReport.CHECK_LIST[field] === value) {
      this.currentReport.CHECK_LIST[field] = null;

      this.checkListProvider.setField(this.currentReport.ID, field, null)
        .subscribe(data => {
          if (!data.success)
            this.logService.error(data);
        });
    }
  }

  cleaarPurchaseAgreement(field: string, value: boolean): void {
    if (field === 'VALUATION_REASON_TYPE' || field === 'SBA_PURPOSE') {
      // TODO
    }
    else if (field === 'P_NA') {
      if (this.currentReport.CHECK_LIST.P_NA) {

        this.currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE = null;
        this.currentReport.CHECK_LIST.P_PA = false;
        this.currentReport.CHECK_LIST.P_LOIP = false;

        this.checkListProvider.setField(this.currentReport.ID, 'PURCHASE_AGREEMENT_TYPE', null)
          .subscribe(data => {
            if (!data.success) {
              this.logService.error(JSON.stringify(data, null, 2));
            }
          });
      }
    } else {
      if (this.currentReport.CHECK_LIST.P_NA === true || value === false) {
        this.currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE = null;
        this.currentReport.CHECK_LIST.P_NA = false;
        this.checkListProvider.setField(this.currentReport.ID, 'PURCHASE_AGREEMENT_TYPE', null)
          .subscribe(data => {
            if (!data.success) {
              this.logService.error(JSON.stringify(data, null, 2));
            }
          });
      }
    }
  }


  get isDisabled(): boolean {
    // for old ways
    if(this.currentReport.DOCUMENT_ID && this.currentReport.DOCUMENTS.length === 0)
      return this.isLocked ? !!this.currentReport.DOCUMENT_ID || this.currentReport.STAGE.ORDER >= 5 : false;
    else
      return this.isLocked ? !!this.currentReport.DOCUMENTS.length || this.currentReport.STAGE.ORDER >= 5 : false;
  }

  /* get isChecklistDisabled(): boolean {
    return this.currentReport.STATE.ID === 'LST' || this.currentReport.STATE.ID === 'CCD' || this.currentReport.STATE.ID === 'CMP';
  } */

  isActiveEdit(): boolean {
    return this.currentReport.STATE.ID !== 'CCD';
  }

  onSelectAllFull(check: CheckListEntityDetails): void {
    check.selected = !check.selected;
    for (const is of check.FINANCIALS) {
      if (!is.isFullDisable())
        if (is.FULL !== check.selected)
          is.FULL = check.selected;
    }

    this.checkListProvider.setDataFullField(this.currentReport.ID, check.ID, 'FULL', check.selected)
      .subscribe(data => {
        if (!data.success) {
          this.logService.error(data);
        }
      });
  }

  onSameSelected(check: CheckListEntityDetails, value: any): void {
    this.isLoading = true;
    this.checkListProvider.setDataFullField(this.currentReport.ID, check.ID, 'IS_BASIS', check.same)
      .subscribe(data => {
        if (data.success) {
          for (const is of check.FINANCIALS) {
            if (!is.isFullDisable())
              is.IS_BASIS = value;
          }
        }

        this.isLoading = false;
      }, err => {
        this.logService.log(err);
        this.isLoading = false;
      });
  }

  onBSSameSelected(check: CheckListEntityDetails, value: any): void {
    this.isLoading = true;
    this.checkListProvider.setDataFullField(this.currentReport.ID, check.ID, 'BS_BASIS', check.bs_same)
      .subscribe(data => {
        if (data.success) {
          for (const is of check.FINANCIALS) {
            if (!is.isBsBasisClear())
              is.BS_BASIS = value;
          }
        }

        this.isLoading = false;
      }, err => {
        this.logService.error(err);
        this.isLoading = false;
      });
  }

  isAllFullChecked(check: CheckListEntityDetails): void {
    let isFull = true;
    for (const is of check.FINANCIALS) {
      if (!is.isFullDisable())
        if (!is.FULL)
          isFull = false;
    }

    check.selected = isFull;
  }

  getEntityName(entity: CorporateEntity): string {
    return this.currentReport.ENTITIES.find(listEntity => listEntity.ID === entity.ID).NAME;
  }

  onValueTouched(value: boolean): void {
    this.isDirtyFlag = value;
  }

  setBsDate(value: string, details: CheckListEntityDetails): void {
    details.FINANCIALS.sort((a, b) => a.YEAR - b.YEAR);
    const data = [details.FINANCIALS[3]];
    let date = moment(value).format('YYYY-MM-DD');
    this.checkListProvider.changeDate(this.currentReport.ID, details.ID, data, date)
      .subscribe(data => {
        if (data.success) {
          const dbCheckDetails = CheckListEntityDetails.parse(data.result);
          details.BS_ENTITY_CHECK_DATE = dbCheckDetails.BS_ENTITY_CHECK_DATE;
          details.FINANCIALS[3].BS_DATE = dbCheckDetails.BS_ENTITY_CHECK_DATE;
        } else this.logService.error(JSON.stringify(data, null, 2));
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private findOrAddBasisValue(value: string, field: string, fin: CheckListEntityFinancials): void {
    let valueFound = false;
    if (value != null) {
      for (const p of this.finBasisValues) {
        if (p.getValue() === value) {
          valueFound = true;
        }
      }

      if (value && !valueFound) {
        const pv = PresetValue.create(value, value);
        this.finBasisValues.push(pv);
      }
    }
  }

  addCustomDocument(): void {
    if (!this.isDisabled) {
      this.checkListProvider.addCustomDocument(this.currentReport.ID).subscribe(data => {
        if (data.success) {
          if (!this.currentReport.CHECK_LIST.CUSTOM_DOCUMENTS)
            this.currentReport.CHECK_LIST.CUSTOM_DOCUMENTS = [];

          this.newDoc = CustomDocuments.parse(data.result);
          this.newDoc.VALUE = true;
          this.currentReport.CHECK_LIST.CUSTOM_DOCUMENTS.push(this.newDoc);
        }
      });
    }
  }
  onCustomDocumentValueChanged(document: CustomDocuments): void {
    this.checkListProvider.updateDocument(this.currentReport.ID, document)
      .subscribe(data => {
        if (!data.success) {
          this.logService.error(JSON.stringify(data, null, 2));
        }
      });
  }

  onRemove(event: any, customDocument: CustomDocuments): void {
    if (event) {
      this.confirmDelete = this.modalService.show(ConfirmDeleteCustomDocumentModal, Helpers.getModalConfig());
      const ackSubject = new Subject<boolean>();
      this.confirmDelete.content.subject = ackSubject;

      ackSubject.subscribe(value => {
        if (value) {
          this.checkListProvider.deleteDocument(this.currentReport.ID, customDocument.ID)
            .subscribe(data => {
              if (data.success) {
                this.currentReport.CHECK_LIST.CUSTOM_DOCUMENTS.splice(
                  this.currentReport.CHECK_LIST.CUSTOM_DOCUMENTS.indexOf(customDocument), 1);
              }
            });
        }
      });
    }
  }

  onEditClientUser(): void {
    this.editModal = this.modalService.show(CreateNewClientUserModal, Helpers.getModalConfig());
    const clUsrAckSubject = new Subject<boolean>();
    this.editModal.content.subject = clUsrAckSubject;
    this.editModal.content.clientUser = this.getClientUserEngagedUser().CLIENT_USER;
    this.editModal.content.manageFlag = true;
    this.editModal.content.isEdit = true;
    clUsrAckSubject.subscribe(value => {
      if (value) {
        this.logService.log(value);
      }
    });
  }

  private getClientUserEngagedUser(): ReportClientUser {
    if (this.currentReport.CLIENT_USERS) {
      for (const cl of this.currentReport.CLIENT_USERS)
        if (cl.EMAIL_ENGAGE === true)
          return cl;
    }
    return null;
  }

  setAccountReceivableDate(detail: CheckListEntityDetails): void {
    this.checkListProvider.setDataField(this.currentReport.ID, detail.ID, 'AR_DATE',
      detail.AR_DATE ? moment(detail.AR_DATE).format('YYYY-MM-DD') : null)
      .subscribe(data => {
        if (!data.success)
          this.logService.error(data);
      });
  }

  setAccountPayableDate(detail: CheckListEntityDetails): void {
    this.checkListProvider.setDataField(this.currentReport.ID, detail.ID, 'AP_DATE',
      detail.AP_DATE ? moment(detail.AP_DATE).format('YYYY-MM-DD') : null)
      .subscribe(data => {
        if (!data.success)
          this.logService.error(data);
      });
  }

  onDownloadPdf(): void {
    this.isLoadingPreview = true;
    this.reportProvider.getEngagementLetterPreview(this.currentReport.ID, this.currentMode)
      .subscribe(response => {
        this.isLoadingPreview = false;
        const blob = new Blob([response], { type: 'application/pdf' });
        FileSaver.saveAs(
          blob, 'Reliant Business Valuation - Engagement Letter.pdf');

      }, error => {
        this.isLoadingPreview = false;
        this.logService.error(error);
      });
  }

  engageFile(): void {
    const factory = this.resolver.resolveComponentFactory(EngageReportFileModal);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;

    const ackSubject = new Subject<boolean>();
    this.tooltip.instance.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value === true) {
        this.currentReport.show_bvq_button = true;
        this.currentReport.HAS_BVQ = true;
        this.router.navigate(['/report', this.currentReport.ID, 'general']);
      }

      if (this.tooltip) {
        this.tooltip.destroy();
      }
    });
  }

  refreshReport(): void {
    this.reportProvider.getReportById(this.currentReport.ID)
      .subscribe(
        data => {
          if (data.success)
            this.reportService.setReport(Report.parse(data.result));
          else {
            this.logService.error(data);
          }
        }, err => {
          this.logService.error(err);
        });
  }

  isDisableFull(fin: CheckListEntityFinancials): boolean {
    if (fin.BS_TYPE == null || fin.BS_TYPE === FinancialType.NOT_AVAILABLE || fin.BS_TYPE === FinancialType.REQUEST) {
      fin.FULL = false;
      return true;
    }

    return false;
  }

  isTRFValid(trv: any): boolean {
    return trv.length === 0 ? true : false;
  }

  canBeSkipped(): boolean {
    return !this.isDirtyFlag;
  }

  isFormSubmitted(): boolean {
    return false;
  }

  isFormValid(): boolean {
    return false;
  }

  showInvalidFields(): void {
  }

  submitForm(): Promise<boolean> {
    return undefined;
  }

  submitFormNext(): void {
  }

  remindClient(): void {
    const config = Helpers.getModalConfig();
    config.class = 'modal-dialog-centered';

    this.confirmationModal = this.modalService.show(ConfirmationDialogComponent, config);
    const ackSubject = new Subject<any>();
    this.confirmationModal.content.subject = ackSubject;
    this.confirmationModal.content.title = 'Send Reminder to Client';
    this.confirmationModal.content.text = 'Do you really want to send a Reminder to the Client?';
    this.confirmationModal.content.actionButton = 'Yes';
    this.confirmationModal.content.actionButtonClass = '';

    ackSubject.subscribe(value => {
      if (value) {
        this.reportProvider.sendReminder(this.currentReport.ID)
          .subscribe(
            data => {
              if (!data.success)
                this.logService.error(data);
            }, err => {
              this.logService.error(err);
            });
      }
    });
  }

  onValuationReasontypeChanged(value: any): void {
    let saveField = value != null ? value.VALUE : null;
    this.currentReport.CHECK_LIST.VALUATION_REASON_TYPE = saveField;
    this.setReasonFieldForValuationType('VALUATION_REASON_TYPE', saveField);
  }

  onBusinessFormValueChanged(value: any, entity: CorporateEntity): void {
    entity.TYPE = value != null ? value.VALUE : null;
    this.reportEntityProvider.save(entity.ID, 'TYPE', entity.TYPE)
      .subscribe(data => {
        if (!data.success)
          this.logService.log(data);
      });
  }

  onStateValueChange(value: any, entity: CorporateEntity): void {
    entity.STATE_INCORPORATED = value != null ? value.VALUE : null;
    this.reportEntityProvider.save(entity.ID, 'STATE_INCORPORATED', entity.STATE_INCORPORATED)
      .subscribe(data => {
        if (!data.success)
          this.logService.log(data);
      });
  }

  dateMask(e): void {
    if (e.target.value) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '' + x[1] + '/' + x[2] + (x[3] ? '/' + x[3] : '');
    }
  }

  companyIncorporatedChange(entity: CorporateEntity): void {
    if (this.checkValidDate(entity)) {
      if(this.isBVQ){
        this.bvqReportService.corporateEntityFieldChanged(entity, 'DATE_INCORPORATED', entity.DATE_INCORPORATED);
      }
      else {
        this.reportEntityProvider.save(entity.ID, 'DATE_INCORPORATED', entity.DATE_INCORPORATED)
          .subscribe(data => {
            if (!data.success)
              this.logService.log(data);
          });
      }
    }
  }

  /** Check valid date */
  checkValidDate(entity: CorporateEntity): boolean{
    if(entity.DATE_INCORPORATED.length === 0)
      return true;

    if(entity.DATE_INCORPORATED && entity.DATE_INCORPORATED.toString().length === 10 && new Date(entity.DATE_INCORPORATED)){
      if(!moment(entity.DATE_INCORPORATED, 'MM/DD/YYYY', true).isValid() ||
        moment(entity.DATE_INCORPORATED, 'MM/DD/YYYY').isAfter(moment()))
        return false;
      else
        return true;
    } else {
      return false;
    }
  }

  /**
   * Download Signed Document.
   */
  downloadDocument(event: MouseEvent, doc: Document): void {
    event.stopImmediatePropagation();
    doc.disabled = true;
    this.isDownloadCombineLoading = true;

    this.documentProvider.downloadDocument(this.currentReport.ID, doc.ID)
      .subscribe(resp => {
        this.saveToFileSystem(resp, `Reliant Business Valuation - ${this.getNameByType(doc.DOCUMENT_TYPE)}.pdf`);
        doc.disabled = false;
        this.isDownloadCombineLoading = false;
      }, error => {
        doc.disabled = false;
        this.isDownloadCombineLoading = false;
        this.logService.log(error.message);
      });
  }

  downloadDocumentZip(event: MouseEvent, doc: Document): void {

    event.stopImmediatePropagation();

    doc.disabled = true;
    this.isDownloadZipLoading = true;
    this.documentProvider.downloadDocumentArchive(this.currentReport.ID, doc.DOCUMENT_ID)
      .subscribe(resp => {
        this.saveToFileSystem(resp, `${this.getNameByType(doc.DOCUMENT_TYPE)} - ${this.currentReport.getName()}.zip`);
        doc.disabled = false;
        this.isDownloadZipLoading = false;
      }, error => {
        doc.disabled = false;
        this.isDownloadZipLoading = false;
        this.logService.log(error.message);
      });
  }

  voidDocument(doc: Document): void {
    const config = Helpers.getModalConfig();
    config.class = 'modal-dialog-centered';

    this.confirmationModal = this.modalService.show(DocumentsActionModal, config);
    const ackSubject = new Subject<boolean>();

    this.confirmationModal.content.subject = ackSubject;
    this.confirmationModal.content.title = 'Void Document';
    this.confirmationModal.content.text = 'Do you really want to void this Document?';
    this.confirmationModal.content.currentReport = this.currentReport;
    this.confirmationModal.content.document = doc;
    this.confirmationModal.content.documentAction = DocumentActionType.VOID_DOCUMENET;

    ackSubject.subscribe(result => {
      if (result) {
        doc.DOCUMENT_STATE = DocumentState.voided;
        doc.disabled = false;
      }
    });
  }

  remindClientEngLetter(doc: Document): void {
    const config = Helpers.getModalConfig();
    config.class = 'modal-dialog-centered';

    this.confirmationModal = this.modalService.show(DocumentsActionModal, config);
    const ackSubject = new Subject<any>();

    this.confirmationModal.content.subject = ackSubject;
    this.confirmationModal.content.title = 'Send Reminder to Client';
    this.confirmationModal.content.text = 'Do you really want to send a Reminder to the Client?';
    this.confirmationModal.content.currentReport = this.currentReport;
    this.confirmationModal.content.document = doc;
    this.confirmationModal.content.documentAction = DocumentActionType.SEND_REMINDER;

    ackSubject.subscribe(value => {
      if (value) {
      }
    });
  }

  private getNameByType(type: DocumentType): string {
    switch (type) {
      case DocumentType.ENGAGEMENT_LETTER:
        return 'Engagement Letter';
      default:
        return 'Document';
    }
  }

  /**
   * Save response to file system.
   * @param response
   * @param fileName
   */
  private saveToFileSystem(response, fileName: string): void {
    const blob = new Blob([response], {});
    saveAs(blob, fileName);
  }

  preventClose(event: MouseEvent): void {
    event.stopImmediatePropagation();
  }

  /**
   * DocuSign Button will be active if DocumentState is not PENDING or EXECUTED
   */
  isDocuSignActive(): boolean {
    if(this.currentReport.DOCUMENT_ID && this.currentReport.DOCUMENTS.length === 0){
      if(this.currentReport.DOCUMENT_STATE === DocumentState.pending || this.currentReport.DOCUMENT_STATE === DocumentState.executed)
        return false;
    }
    else if(this.currentReport.DOCUMENTS){
      if (this.currentReport.DOCUMENTS.length > 0)
        for (let doc of this.currentReport.DOCUMENTS)
          if (doc.DOCUMENT_STATE === DocumentState.pending || doc.DOCUMENT_STATE === DocumentState.executed)
            return false;
    }

    return true;
  }

  showInfo(): void {
    const factory = this.resolver.resolveComponentFactory(RequestInfoModal);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;

    const ackSubject = new Subject<boolean>();
    this.tooltip.instance.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        this.currentReport.INITIAL_SENT = true;
      }

      if (this.tooltip) {
        this.tooltip.destroy();
      }
    });
  }
}
